import { OrderTabView } from "@mcleod/dispatch";
import { AutogenLayoutBreakthroughFuelHistoryList } from "./autogen/AutogenLayoutBreakthroughFuelHistoryList";
import { Label, TableRow, TableRowDisplayEvent } from "@mcleod/components";

const ORDER_FIELD = "order_id";

export class BreakthroughFuelHistoryList extends AutogenLayoutBreakthroughFuelHistoryList {
    setupOrderLink(comp: Label, tableRow: TableRow) {
        const orderId = tableRow.data.get(ORDER_FIELD);
        if (orderId) {
            comp.applyLinkStyle();
            comp.addClickListener(() => {
                OrderTabView.navigateTo({ key: orderId, newTab: true });
            });
        }
    }

    /** This is an event handler for the onRowDisplay event of tableBreakthrough. */
    tableBreakthroughOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        this.setupOrderLink(tableRow.findComponentsByField(ORDER_FIELD)[0] as Label, tableRow); 
    }
}
